// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__IuIx1","main":"layout_main__sBRdT","content":"layout_content__hXYjP"};